import withEntry from '../../../components/shared/withEntry';
import withLocalMessage from '../../../components/LocaleMessage';
import withModalEntry from '../../../components/shared/EntryWrapper';
import { EntryTypes } from '../../../utils/types/entry';

export const LanguageSelectionModalEntry = withEntry(
    withLocalMessage({ LanguageSelectionComponent: withModalEntry(EntryTypes.languageSelectionTrigger) })
);
